import BehaviorConfig from '@/models/app-config/behavior/behavior'
import {
  defaultCompletedParts,
  fitowaCompletedParts,
  mycolorCompletedParts,
  SignUpCompletedPageParts,
  vilbCompletedParts,
} from './completed-page-parts'

export function createSignUpCompletedPageParts(
  behavior: BehaviorConfig
): SignUpCompletedPageParts {
  if (behavior.isVilb) return vilbCompletedParts(behavior)

  if (behavior.isFitowa) return fitowaCompletedParts(behavior)

  if (behavior.isMyColor) return mycolorCompletedParts(behavior)

  return defaultCompletedParts()(behavior)
}
